import { render } from "./NamedNumberedMenuSection.vue?vue&type=template&id=483e8cf2"
import script from "./NamedNumberedMenuSection.vue?vue&type=script&lang=js"
export * from "./NamedNumberedMenuSection.vue?vue&type=script&lang=js"

import "./NamedNumberedMenuSection.vue?vue&type=style&index=0&id=483e8cf2&lang=css"
script.render = render

export default script